__turbopack_context__.v({
  "img": "HeroImage-module__YNEWoW__img",
  "imgsNum": "HeroImage-module__YNEWoW__imgsNum",
  "racBadge": "HeroImage-module__YNEWoW__racBadge",
  "wrpr": "HeroImage-module__YNEWoW__wrpr",
});
